import React from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-modal';

import Button from '../../Common/Button';
import Icon from "../../Common/Icon";
import { WrapperContent } from "../ModalAddChat/components";
import {ReactComponent as CloseIcon} from "../../../../img/dialog-close.svg";

class ModalDeleteChat extends React.PureComponent {
  constructor(props) {
    super(props);
  }

  onPressClose = (event) => this.props.onClose(event);

  onPressSave = async (event) => {
    this.props.onSubmit();
    this.props.onClose(event);
  };

  render() {

    return (
      <Modal
        isOpen
        onRequestClose={ this.onPressClose }
        contentLabel='Delete Channel'
        className='Modal_Content'
        overlayClassName='Modal_Overlay Modal_Overlay_Chat'
      >
        <div className='Modal_Content_Container Modal_Content_Container_Delete'>
          <h2>
            Delete channel
          </h2>
          <div className='Content'>
            <WrapperContent>
              <p><b>Are you sure?</b></p>
              <p>You will no longer be able to participate from this channel.</p>
            </WrapperContent>
            <div className='Modal_Content_Actions Center'>
              <Button className='Inline Button_Small'
                onClick={ this.onPressSave  }
              >
                Confirm
              </Button>
              <Button className='Button_Black Inline Button_Small'
                onClick={ this.onPressClose }
              >
                Cancel
              </Button>
            </div>
          </div>
          <div className='Modal_Content_Close' onClick={ this.onPressClose }>
            <Icon className='Icon-Close' width='12' height='12' color='secondaryColor'>
              <CloseIcon alt='icon-close'/>
            </Icon>
          </div>
        </div>
      </Modal>
    );
  }
}

ModalDeleteChat.propTypes = {
  onClose: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
};

export default ModalDeleteChat;
